module.exports = __webpack_public_path__ + "static/media/6.da568c57.JPG";